/* eslint-disable prettier/prettier */
import DOMPurify from 'dompurify';
import Typograf from 'typograf';
// Константы и утилиты для работы с символами
var symbolsToReplace = {
    '+': '&plus;',
    '*': '&ast;',
    '\u000b': ' '
};
var replaceSymbol = function (symbol) { return symbolsToReplace[symbol] || symbol; };
var replaceSymbols = function (str) {
    return str
        .replace(/[+*]/g, replaceSymbol)
        .split('\u000b')
        .join(replaceSymbol('\u000b'));
};
/**
 * Проверяет, находится ли позиция внутри HTML-тега
 */
var isInsideHtmlTag = function (text, position) {
    var textBefore = text.substring(0, position);
    var lastTagOpen = textBefore.lastIndexOf('<');
    var lastTagClose = textBefore.lastIndexOf('>');
    return lastTagOpen > lastTagClose;
};
/**
 * Проверяет, находится ли позиция внутри существующей ссылки
 */
var isInsideExistingLink = function (text, position) {
    var textBefore = text.substring(0, position);
    var lastLinkStart = textBefore.lastIndexOf('<a ');
    var lastLinkEnd = textBefore.lastIndexOf('</a>');
    return lastLinkStart > lastLinkEnd;
};
/**
 * Сохраняет специальные последовательности типа a!b!c
 * чтобы Typograf не добавлял пробелы после !
 */
var protectSpecialSequences = function (text) {
    var sequences = new Map();
    var counter = 0;
    var protectedText = text.replace(/([A-Za-z]{2,}!)+[A-Za-z]{2,}/g, function (match) {
        var key = "PROTECTED_SEQUENCE_".concat(counter++);
        sequences.set(key, match);
        return key;
    });
    return { protectedText: protectedText, sequences: sequences };
};
/**
 * Восстанавливает защищенные последовательности
 */
var restoreProtectedSequences = function (text, sequences) {
    var result = text;
    sequences.forEach(function (value, key) {
        result = result.replace(new RegExp(key, 'g'), value);
    });
    return result;
};
/**
 * Очищает HTML через DOMPurify и восстанавливает атрибуты ссылок
 */
var cleanHTML = function (rawHTML) {
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = rawHTML;
    tempDiv.querySelectorAll("a").forEach(function (link) {
        if (link.getAttribute("target") === "_blank") {
            link.setAttribute("data-target", "blank");
        }
    });
    var sanitizedHTML = DOMPurify.sanitize(tempDiv.innerHTML, {
        USE_PROFILES: { html: true },
        ALLOWED_URI_REGEXP: /(https|hseverse?:\/\/[^\s]+)/g,
        ALLOW_UNKNOWN_PROTOCOLS: true
    });
    var resultDiv = document.createElement("div");
    resultDiv.innerHTML = sanitizedHTML;
    resultDiv.querySelectorAll("a").forEach(function (link) {
        if (link.hasAttribute("data-target")) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener");
        }
        else {
            link.setAttribute("target", "_self");
        }
    });
    return resultDiv.innerHTML;
};
/**
 * Применяет типографские правила к HTML
 * Список правил: https://github.com/typograf/typograf/blob/dev/docs/RULES_SORTED.ru.md
 */
export var executeTypograf = function (rawHTML) {
    var tp = new Typograf({ locale: ['ru', 'en-US'] });
    tp.disableRule('ru/punctuation/*');
    tp.disableRule('common/symbols/cf');
    return tp.execute(rawHTML);
};
/**
 * Преобразует простые URL в кликабельные ссылки
 * Пропускает URL, которые уже находятся внутри HTML-тегов или существующих ссылок
 */
var convertUrlsToLinks = function (text) {
    var URL_REGEX = /(https?:\/\/[^\s<]+)/g;
    var result = '';
    var lastIndex = 0;
    var match;
    while ((match = URL_REGEX.exec(text)) !== null) {
        var url = match[0];
        var position = match.index;
        // Пропускаем URL внутри тегов или уже существующих ссылок
        var shouldSkip = isInsideHtmlTag(text, position) || isInsideExistingLink(text, position);
        if (!shouldSkip) {
            result += text.substring(lastIndex, position);
            result += "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"".concat(url, "\">").concat(url, "</a>");
            lastIndex = position + url.length;
        }
    }
    result += text.substring(lastIndex);
    return result;
};
/**
 * Экранирует специальные символы и форматирование списков
 */
var escapeMarkdownElements = function (text) {
    return replaceSymbols(text)
        .replace(/^(\d+)\.(\s*\S)/gm, '$1\\.$2') // Нумерованные списки
        .replace(/^(\*\s)(\S)/gm, '\\* $2') // Маркированные списки (*)
        .replace(/^(-\s)(\S)/gm, '\\- $2'); // Маркированные списки (-)
};
// ============================================================================
// Основная функция форматирования
// ============================================================================
/**
 * Форматирует текст: защищает специальные последовательности,
 * преобразует URL в ссылки, применяет типографику
 */
var formatLinks = function (textContent) {
    try {
        // Этап 1: Защита специальных последовательностей (HTML!CSS!JS)
        var _a = protectSpecialSequences(textContent), protectedText = _a.protectedText, sequences = _a.sequences;
        // Этап 2: Экранирование markdown-элементов
        var escapedText = escapeMarkdownElements(protectedText);
        // Этап 3: Преобразование URL в ссылки
        var textWithLinks = convertUrlsToLinks(escapedText);
        // Этап 4: Применение типографики и очистка HTML
        var typographedText = executeTypograf(cleanHTML(textWithLinks))
            .trim()
            .replace(/\+/g, '\\+');
        // Этап 5: Восстановление защищенных последовательностей
        var finalResult = restoreProtectedSequences(typographedText, sequences);
        return finalResult;
    }
    catch (error) {
        console.error('Error in formatLinks:', error);
        return executeTypograf(cleanHTML(textContent));
    }
};
export default formatLinks;
//# sourceMappingURL=formatLinks.js.map/* eslint-disable prettier/prettier */
import DOMPurify from 'dompurify';
import Typograf from 'typograf';
// Константы и утилиты для работы с символами
var symbolsToReplace = {
    '+': '&plus;',
    '*': '&ast;',
    '\u000b': ' '
};
var replaceSymbol = function (symbol) { return symbolsToReplace[symbol] || symbol; };
var replaceSymbols = function (str) {
    return str
        .replace(/[+*]/g, replaceSymbol)
        .split('\u000b')
        .join(replaceSymbol('\u000b'));
};
/**
 * Проверяет, находится ли позиция внутри HTML-тега
 */
var isInsideHtmlTag = function (text, position) {
    var textBefore = text.substring(0, position);
    var lastTagOpen = textBefore.lastIndexOf('<');
    var lastTagClose = textBefore.lastIndexOf('>');
    return lastTagOpen > lastTagClose;
};
/**
 * Проверяет, находится ли позиция внутри существующей ссылки
 */
var isInsideExistingLink = function (text, position) {
    var textBefore = text.substring(0, position);
    var lastLinkStart = textBefore.lastIndexOf('<a ');
    var lastLinkEnd = textBefore.lastIndexOf('</a>');
    return lastLinkStart > lastLinkEnd;
};
/**
 * Сохраняет специальные последовательности типа a!b!c
 * чтобы Typograf не добавлял пробелы после !
 */
var protectSpecialSequences = function (text) {
    var sequences = new Map();
    var counter = 0;
    var protectedText = text.replace(/([A-Za-z]{2,}!)+[A-Za-z]{2,}/g, function (match) {
        var key = "PROTECTED_SEQUENCE_".concat(counter++);
        sequences.set(key, match);
        return key;
    });
    return { protectedText: protectedText, sequences: sequences };
};
/**
 * Восстанавливает защищенные последовательности
 */
var restoreProtectedSequences = function (text, sequences) {
    var result = text;
    sequences.forEach(function (value, key) {
        result = result.replace(new RegExp(key, 'g'), value);
    });
    return result;
};
/**
 * Очищает HTML через DOMPurify и восстанавливает атрибуты ссылок
 */
var cleanHTML = function (rawHTML) {
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = rawHTML;
    tempDiv.querySelectorAll("a").forEach(function (link) {
        if (link.getAttribute("target") === "_blank") {
            link.setAttribute("data-target", "blank");
        }
    });
    var sanitizedHTML = DOMPurify.sanitize(tempDiv.innerHTML, {
        USE_PROFILES: { html: true },
        ALLOWED_URI_REGEXP: /(https|hseverse?:\/\/[^\s]+)/g,
        ALLOW_UNKNOWN_PROTOCOLS: true
    });
    var resultDiv = document.createElement("div");
    resultDiv.innerHTML = sanitizedHTML;
    resultDiv.querySelectorAll("a").forEach(function (link) {
        if (link.hasAttribute("data-target")) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener");
        }
        else {
            link.setAttribute("target", "_self");
        }
    });
    return resultDiv.innerHTML;
};
/**
 * Применяет типографские правила к HTML
 * Список правил: https://github.com/typograf/typograf/blob/dev/docs/RULES_SORTED.ru.md
 */
export var executeTypograf = function (rawHTML) {
    var tp = new Typograf({ locale: ['ru', 'en-US'] });
    tp.disableRule('ru/punctuation/*');
    tp.disableRule('common/symbols/cf');
    return tp.execute(rawHTML);
};
/**
 * Преобразует простые URL в кликабельные ссылки
 * Пропускает URL, которые уже находятся внутри HTML-тегов или существующих ссылок
 */
var convertUrlsToLinks = function (text) {
    var URL_REGEX = /(https?:\/\/[^\s<]+)/g;
    var result = '';
    var lastIndex = 0;
    var match;
    while ((match = URL_REGEX.exec(text)) !== null) {
        var url = match[0];
        var position = match.index;
        // Пропускаем URL внутри тегов или уже существующих ссылок
        var shouldSkip = isInsideHtmlTag(text, position) || isInsideExistingLink(text, position);
        if (!shouldSkip) {
            result += text.substring(lastIndex, position);
            result += "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"".concat(url, "\">").concat(url, "</a>");
            lastIndex = position + url.length;
        }
    }
    result += text.substring(lastIndex);
    return result;
};
/**
 * Экранирует специальные символы и форматирование списков
 */
var escapeMarkdownElements = function (text) {
    return replaceSymbols(text)
        .replace(/^(\d+)\.(\s*\S)/gm, '$1\\.$2') // Нумерованные списки
        .replace(/^(\*\s)(\S)/gm, '\\* $2') // Маркированные списки (*)
        .replace(/^(-\s)(\S)/gm, '\\- $2'); // Маркированные списки (-)
};
// ============================================================================
// Основная функция форматирования
// ============================================================================
/**
 * Форматирует текст: защищает специальные последовательности,
 * преобразует URL в ссылки, применяет типографику
 */
var formatLinks = function (textContent) {
    try {
        // Этап 1: Защита специальных последовательностей (HTML!CSS!JS)
        var _a = protectSpecialSequences(textContent), protectedText = _a.protectedText, sequences = _a.sequences;
        // Этап 2: Экранирование markdown-элементов
        var escapedText = escapeMarkdownElements(protectedText);
        // Этап 3: Преобразование URL в ссылки
        var textWithLinks = convertUrlsToLinks(escapedText);
        // Этап 4: Применение типографики и очистка HTML
        var typographedText = executeTypograf(cleanHTML(textWithLinks))
            .trim()
            .replace(/\+/g, '\\+');
        // Этап 5: Восстановление защищенных последовательностей
        var finalResult = restoreProtectedSequences(typographedText, sequences);
        return finalResult;
    }
    catch (error) {
        console.error('Error in formatLinks:', error);
        return executeTypograf(cleanHTML(textContent));
    }
};
export default formatLinks;
//# sourceMappingURL=formatLinks.js.map